module.exports = __webpack_public_path__ + "static/media/multiple-choice-list-jellyfish.87ea42df.svg";